import { HomeOutlined } from "@ant-design/icons";

const RenderFHIR = (props) => {
  console.log(props.data);

  const { data } = props;

  console.log("data", data);

  const observations = [];
  const conclusion = data.entry.map((item) => {
    if (item.resource.resourceType === "Observation") {
      const obj = {};
      obj.parameter = item.resource.code.text;
      obj.value =
        item.resource.valueQuantity.value +
        " " +
        item.resource.valueQuantity.unit;
      obj.referenceRange =
        item.resource.referenceRange[0].high?.value +
        " " +
        item.resource.referenceRange[0].high?.unit;
      observations.push(obj);
    }
  });

  console.log(observations, "observations");

  const documentReference = [];
  data.entry.map((item) => {
    if (item.resource.resourceType === "DocumentReference") {
      documentReference.push(item.resource);
      //   return item.resource;
    }
  });
  console.log(documentReference, "documentReference");

  console.log(documentReference[0].content[0].attachment.url, "url");

  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "0 auto",
        backgroundColor: "white",
        paddingTop: "25px",
        // boxShadow: "0 0 15px rgba(0,0,0,0.1)",
        // border: "1px solid #ccc",
        borderRadius: "8px"
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "30px",
          border: "2px solid rgb(204 204 204 / 56%)",
          borderRadius: "5px"
        }}
      >
        <tbody>
          <tr>
            <td
              style={{
                width: "50%",
                fontSize: "20px",
                fontWeight: "bold",
                padding: "10px",
                paddingBottom: "0"
              }}
            >
              <span style={{ paddingRight: "10px" }}>
                <HomeOutlined style={{ color: "#FFD43B", fontSize: "30px" }} />
              </span>
              {data.entry[0].resource.custodian.display}
            </td>
            <td
              style={{
                width: "50%"
              }}
            ></td>
          </tr>
          <tr>
            <td
              style={{
                width: "50%",
                fontSize: "13px",
                color: "#666",
                paddingLeft: "50px"
              }}
            >
              Pathkind Labs Gurugram
            </td>
            <td
              style={{
                width: "50%"
              }}
            ></td>
          </tr>
          <tr>
            <td
              style={{
                width: "50%",
                fontSize: "13px",
                color: "#666",
                paddingLeft: "50px"
              }}
            >
              Diagnostic studies report
            </td>
            <td
              style={{
                width: "50%"
              }}
            ></td>
          </tr>
          <tr>
            <td
              style={{
                width: "40%",
                fontSize: "13px",
                color: "#666",
                padding: "10px 0 0 10px"
              }}
            >
              Practitioner Name
            </td>
            <td
              style={{
                width: "60%",
                fontSize: "13px",
                color: "#666",
                textAlign: "right",
                padding: "10px 10px 0 0"
              }}
            >
              Dr. Mohit Tripathi
            </td>
          </tr>
          <tr>
            <td style={{ fontSize: "13px", color: "#666", padding: "0 10px" }}>
              Clinic Name
            </td>
            <td
              style={{
                fontSize: "13px",
                color: "#666",
                textAlign: "right",
                padding: "0 10px"
              }}
            >
              {data.entry[0].resource.custodian.display}
            </td>
          </tr>
          <tr>
            <td style={{ fontSize: "13px", color: "#666", padding: "0 10px" }}>
              Visit Date
            </td>
            <td
              style={{
                fontSize: "13px",
                color: "#666",
                textAlign: "right",
                padding: "0 10px"
              }}
            >
              {new Date(data?.entry[0]?.resource?.date).toLocaleDateString()}
            </td>
          </tr>
          <tr>
            <td style={{ fontSize: "13px", color: "#666", padding: "0 10px" }}>
              Patient Name
            </td>
            <td
              style={{
                fontSize: "13px",
                color: "#666",
                textAlign: "right",
                padding: "0 10px"
              }}
            >
              Gaurav
            </td>
          </tr>
          <tr>
            <td style={{ fontSize: "13px", color: "#666", padding: "0 10px" }}>
              Patient Gender
            </td>
            <td
              style={{
                fontSize: "13px",
                color: "#666",
                textAlign: "right",
                padding: "0 10px"
              }}
            >
              Male
            </td>
          </tr>
          <tr>
            <td
              style={{
                fontSize: "13px",
                color: "#666",
                padding: "0 10px 10px 10px"
              }}
            >
              Patient Birth Date
            </td>
            <td
              style={{
                fontSize: "13px",
                color: "#666",
                textAlign: "right",
                padding: "0 10px 10px 10px"
              }}
            >
              1995-10-08
            </td>
          </tr>
        </tbody>
      </table>

      <div
        style={{
          marginBottom: "30px",
          border: "1px solid #ccc",
          borderRadius: "5px",
          padding: "10px"
        }}
      >
        <h2 style={{ fontSize: "13px", color: "#666", fontWeight: "bold" }}>
          {data.entry[0].resource.section[0].title} - ( DiagnosticReport )
        </h2>

        <div>
          <p style={{ fontSize: "13px", color: "#666", marginBottom: "5px" }}>
            Cholesterol [Mass/volume] in Serum or Plasma{" "}
            <span
              style={{
                marginLeft: "20px",
                fontSize: "13px",
                color: "#666",
                fontWeight: "500"
              }}
            >
              156 mg/dL
            </span>
          </p>
        </div>
        <div>
          <p style={{ fontSize: "13px", color: "#666", marginBottom: "5px" }}>
            Triglyceride [Mass/volume] in Serum or Plasma{" "}
            <span
              style={{
                marginLeft: "20px",
                fontSize: "13px",
                color: "#666",
                fontWeight: "500"
              }}
            >
              146 mg/dL
            </span>
          </p>
        </div>
        <div>
          <p style={{ fontSize: "13px", color: "#666", marginBottom: "5px" }}>
            Cholesterol in HDL [Mass/volume] in Serum or Plasma{" "}
            <span
              style={{
                marginLeft: "20px",
                fontSize: "13px",
                color: "#666",
                fontWeight: "500"
              }}
            >
              45 mg/dL
            </span>
          </p>
        </div>
        <div>
          <p style={{ fontSize: "13px", color: "#666", marginBottom: "5px" }}>
            Lipid 1996 panel
          </p>
        </div>
        <div>
          <p
            style={{
              fontSize: "16px",
              color: "#666",
              marginBottom: "5px",
              fontWeight: "700"
            }}
          >
            Conclusion: Elevated cholesterol/high density lipoprotein ratio
          </p>
        </div>
      </div>

      <div
        style={{
          border: "1px solid #ccc",
          borderRadius: "5px",
          padding: "10px"
        }}
      >
        <h2 style={{ fontSize: "13px", color: "#666", fontWeight: "bold" }}>
          {data.entry[0].resource.section[0].title} - ( DocumentReference )
        </h2>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            margin: "15px 0"
          }}
        >
          <span>
            <i className="fa-solid fa-file" />
          </span>
          <a
            href={documentReference[0].content[0].attachment.url}
            rel="noopener noreferrer"
            target="_blank"
            style={{
              paddingLeft: "7px",
              textDecoration: "none",
              color: "skyblue",
              fontWeight: "600"
            }}
          >
            Laboratory report
          </a>
        </div>
      </div>
    </div>
  );
};

export default RenderFHIR;
